import React from 'react';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

/**
 * 템플릿 다이얼로그 하단 버튼 — 스타일은 SubMatTemplateDialogFooter 의 DialogActions sx 에서 일괄 적용.
 */
const SubMatDialogFooterButton = ({
  loading,
  children,
  ...rest
}) => {
  if (loading !== undefined) {
    return (
      <LoadingButton loading={loading} disableElevation {...rest}>
        {children}
      </LoadingButton>
    );
  }

  return (
    <Button disableElevation {...rest}>
      {children}
    </Button>
  );
};

export default SubMatDialogFooterButton;
